import React from "react";

export default function TechnicianHours() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-white">
      <div className="w-full max-w-2xl bg-white rounded-3xl shadow-lg p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Working Hours
        </h1>
        <p className="text-sm text-gray-600">
          Here you will configure your working hours and availability for bookings.
        </p>
      </div>
    </div>
  );
}
